import { FC, useMemo } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectResult } from "store/player/playerSelectors";
import IQuestion from "models/Question";
//
import ReactApexChart from "react-apexcharts";

type Props = {
  question: IQuestion;
  isLargeScreen: boolean;
}

const QuestionItem:FC<Props> = ({ question, isLargeScreen }) => {
  const result = useAppSelector(selectResult);

  const results = result.results || [];

  const questionResults = results.find((r:any) => r.questionRef === question.ref);

  const width = useMemo(() => {
    return isLargeScreen ? 500 : 380
  }, [isLargeScreen])

  if (!questionResults) return null;

  const series = question.answers.map((answer) => questionResults.answers[answer.ref] || 0);

  const options:any = {
    chart: {
      width,
      type: 'pie',
    },
    labels: question.answers.map(answer => answer.title),
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width
        },
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: false,
        }
      }
    }],
    legend: {
      labels: {
        colors: '#eee'
      }
    }
  }

  return (
    <div>
      <h3 className="mb-2 text-white font-bold text-center lg:text-left">{question.title}</h3>
      <ReactApexChart options={options} series={series} type="pie" width={width} />
    </div>
  );
}
 
export default QuestionItem;
